import React, { useState } from "react";
import { CiMail } from "react-icons/ci";
import { MdOutlinePhone } from "react-icons/md";
import axios from "axios";

// Backend API base URL
const BASE_URL = "https://dgl-core-9x7.dailygolive.in";

function ContactPage() {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;

    // Only numbers allowed in phone & limit to 10 digits
    if (id === "phone") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }

    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check phone length before submit
    if (formData.phone.length !== 10) {
      alert("❌ Phone number must be exactly 10 digits");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/api/contact`, formData);
      alert(res.data.message || "✅ Message sent successfully");
      setFormData({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (err) {
      console.error("Error submitting form:", err);
      alert(
        err.response?.data?.message ||
          "❌ Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <section className="w-full mx-auto py-12 px-4 sm:px-8 lg:px-16 bg-[#dcf5de]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          {/* Left Section */}
          <div>
            <h1 className="text-3xl sm:text-4xl font-bold text-[#19471b] mb-4">
              Contact Us
            </h1>
            <div className="text-gray-600 pb-3 mb-8">
              <p className="mb-6">
                Email, call, or complete the form to learn how Daily Go <br /> can
                solve your messaging problem.
              </p>
              <p className="mb-4 flex items-center">
                <CiMail color="green" strokeWidth={1} className="mr-3" />
                office-info@dailygolive.in
              </p>
              <p className="mb-4 flex items-center">
                <MdOutlinePhone color="green" className="mr-3" /> +91 6362022176
              </p>
              <p className="mb-4 text-black underline font-medium">
                <a href="#">Customer Support</a>
              </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                {
                  title: "Customer Support",
                  desc: "Our support team is available 24/7 to help with any questions, issues, or order-related concerns.",
                },
                {
                  title: "Feedback",
                  desc: "We value your feedback and use it to improve DailyGo every day.",
                },
                {
                  title: "Media Inquiries",
                  desc: "For all media-related inquiries, please contact us at abcd@gmail.com",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="bg-[#dcf5de] px-4 py-5 rounded-lg drop-shadow-2xl"
                >
                  <h3 className="mb-2 text-lg font-semibold text-[#19471b] underline">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right Section - Form */}
          <div className="bg-white p-6 sm:p-8 rounded-lg drop-shadow-2xl">
            <h2 className="text-2xl font-semibold mb-1 text-black">Get In Touch</h2>
            <h6 className="mb-7 text-sm text-gray-600">
              You can reach us any time
            </h6>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input
                  type="text"
                  id="firstname"
                  value={formData.firstname}
                  onChange={handleChange}
                  required
                  placeholder="First Name"
                  className="drop-shadow-lg border border-gray-300 rounded-3xl py-2 px-3 text-black w-full"
                />
                <input
                  type="text"
                  id="lastname"
                  value={formData.lastname}
                  onChange={handleChange}
                  required
                  placeholder="Last Name"
                  className="drop-shadow-lg border border-gray-300 rounded-3xl py-2 px-3 text-black w-full"
                />
              </div>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Email"
                className="drop-shadow-lg border border-gray-300 rounded-3xl py-2 px-3 text-black w-full"
              />
              <input
                type="tel"
                id="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder="Phone number"
                maxLength={10}
                className="drop-shadow-lg border border-gray-300 rounded-3xl py-2 px-3 text-black w-full"
              />
              <textarea
                id="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
                placeholder="How can we help you?"
                className="drop-shadow-lg border border-gray-300 rounded-3xl py-2 px-3 text-black w-full"
              ></textarea>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#19471b] hover:bg-[#217824] text-white font-bold py-2 px-4 rounded-3xl"
              >
                {loading ? "Sending..." : "Submit"}
              </button>
              <p className="text-gray-800 text-xs sm:text-sm text-center">
                By contacting us, you agree to our{" "}
                <strong>Terms of Service</strong> and{" "}
                <strong>Privacy Policy</strong>
              </p>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;
